import React, { Component } from 'react';
import Sidebar from '../sideBar';
import StatusSideBar from '../myCourse/statusSideBar';
import ScoreBar from '../common/score';

const DefaultLayoutHOC = (WrappedComponent) => {
	return class extends Component {
		render() {
			const { show, showStatusSideBar, hideSidebar } = this.props;
			return (
				<>
					<section className="step-container align-stretch container">
						{!hideSidebar &&
							window.outerWidth > 768 &&
							localStorage.getItem('paymentInProcess') !== '1' && <Sidebar />}
						<div className="page-right-section">
							<div className="dashboard-page ">
								<div className="db-body ">
									<WrappedComponent {...this.props} />
								</div>
								{show && localStorage.getItem('active_course_id') !== '428' && (
									<ScoreBar />
								)}
								{/*{showStatusSideBar && <StatusSideBar />}*/}
							</div>
						</div>
					</section>
				</>
			);
		}
	};
};

export default DefaultLayoutHOC;
